import { render, staticRenderFns } from "./App.vue?vue&type=template&id=5fcfc8d0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=5fcfc8d0&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chaipeng/Desktop/Mico/micous-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fcfc8d0')) {
      api.createRecord('5fcfc8d0', component.options)
    } else {
      api.reload('5fcfc8d0', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=5fcfc8d0", function () {
      api.rerender('5fcfc8d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/views/web/home/components/App.vue"
export default component.exports